export default {
  'profile.updatesuccess': 'Ваш профиль успешно обновлен',
  'profile.insertsuccess': 'Ваш профиль успешно обновлен',
  'profile.profile': 'Профиль',
  'profile.search': 'Поиск',
  'profile.oldpassword': 'Старый пароль',
  'profile.newpassword': 'Новый пароль',
  'profile.logo': 'Лого',
  'profile.workinghours': 'Рабочее время',
  'profile.nationalcardfile': 'Файл Национальной карты',
  'profile.addfile': 'Добавить файл',
  'profile.editinformation': 'Изменить информацию профиля',
  'profile.email': 'Эл. Почта',
  'profile.weekdays': 'Дни недели',
  'profile.close': 'Закрыть',
  'profile.savechanges': 'Сохранить изменения',
  'profile.deleteconfirmation': 'Вы уверены, что хотите удалить?',
  'profile.rolename': 'Имя роли',
  'profile.register': 'Регистрация',
  'profile.delete': 'удалять',
  'profile.addemployee': 'Добавить нового сотрудника',
  'profile.deleteemployee': 'Удалить сотрудника',
  'profile.cancel': 'Отмена',
  'profile.number': 'номер',
  'profile.fromtime': 'От времени',
  'profile.totime': 'На времени',
  'profile.setworkinghours': 'Установить рабочее время',
  'profile.phone': 'телефон {индекс}',
  'profile.selectyear': 'Выберите год',
  'profile.selectmonth': 'Выберите месяц',
  'profile.selectday': 'Выберите день',
  'profile.address': 'Адрес {индекс}',
  'profile.companyname': 'Название компании',
  'profile.englishcompanyname': 'Английское название компании',
  'profile.persiancompanyname': 'Название  компании на Фарси',
  'profile.removeaddress': 'Удалить адрес',
  'profile.moreaddress': 'Добавить адрес',
  'profile.removephone': 'Удалить телефон',
  'profile.addphone': 'Добавить телефон',
  'profile.registercode': 'Регистрационный код',
  'profile.managername': 'Имя менеджера / агента(необходимые)',
  'profile.businessmanagername': 'Имя менеджера',
  'profile.type': 'тип бизнеса(необходимые)',
  'profile.businesstype': 'тип бизнеса',
  'profile.licensefile': 'Файл лицензии',
  'profile.updatepassword': 'Пожалуйста, обновите ваш пароль, чтобы продолжить',
  'profile.editprofile': 'РЕДАКТИРОВАТЬ БИЗНЕС-ПРОФИЛЬ',
  'profile.individualprofile': 'РЕДАКТИРОВАТЬ ПРОФИЛЬ',
  'profile.inviteemployee': 'Пригласить сотрудника',
  'profile.change': 'Изменение',
  'profile.firstname': 'Имя',
  'profile.lastname': 'Фамилия',
  'profile.mobile': 'мобильный',
  'profile.nationalcode': 'Национальный Код',
  'profile.password': 'Пароль',
  'profile.username': 'имя пользователя',
  'profile.username/email': 'Имя пользователя / эл. почта',
  'profile.gender': 'Пол',
  'profile.birthdate': 'Дата рождения',
  'profile.selectavatar': 'Выберите Аватар',
  'profile.adminitstrator': '	администратор',
  'profile.book/reserve': 'Мои заказы',
  'profile.businessbooking': 'Мои заказы',
  'profile.changepassword': 'Изменить пароль',
  'profile.editpersonalprofile': 'Редактировать профиль ',
  'profile.onlinesupport': 'Онлайн поддержка',
  'profile.employee': 'Сотрудник',
  'profile.addprofile': 'ДОБАВИТЬ НОВЫЙ БИЗНЕС-ПРОФИЛЬ',
  'profile.addbusiness': 'ДОБАВИТЬ БИЗНЕС',
  'profile.encompanyname': 'Английское название компании(необходимые)',
  'profile.facompanyname': 'Название местной компании(необходимые)',
  'profile.myProfile': 'МОЙ ПРОФАЙЛ',
  'profile.textProfile':
    'В этом разделе вы можете увидеть информацию своего профиля',

  'profile.employeemanagement': 'Управление персоналом',
  'profile.airlinequota': 'Авиакомпания Цитата',
  'profile.signiture': 'ПОДПИСЬ ПРОФИЛЯ',
  'profile.addsigniture': 'СОХРАНИТЬ ПОДПИСЬ',
  'profile.quotaadd': 'Квота успешно добавлена',
  'profile.signout': 'Выйти',
  'profile.signituresave': 'Подпись успешно сохранена',
  'profile.signitureerror': 'Пожалуйста, попробуйте еще раз',
  'profile.profiletype': 'ВЫБЕРИТЕ ТИП ПРОФИЛЯ',
  'profile.profilsend':
    'Профиль отправлен на проверку. Результаты будут объявлены в ближайшее время.',
  'profile.suspend': 'ПРИОСТАНОВИТЬ',
  'profile.nationalid': 'Национальный ID(необходимые)',
  'profile.activitycode': 'код активации(необходимые)',
  'profile.economiccode': 'Экономический код(необходимые)',
  'profile.businessnationalid': 'Национальный ID',
  'profile.businessactivitycode': 'код активации',
  'profile.businesseconomiccode': 'Экономический код',
  'profile.choosegateway': 'Выберите формы платежа',
  'profile.testconnection': 'Пров.соед',
  'profile.savesigniture': 'Сохранить подпись',
  'profile.signitureping': 'Форма оплаты успешно сохранен',
  'profile.country': 'Страна',
  'profile.city': 'Город',
  'profile.role': 'Роль',
  'profile.whoareyou': 'Кто ты?',
  'profile.license': 'Лицензия',
  'profile.viewlicense': 'Просмотреть лицензии',
  'profile.walletremain': 'Кошелек остается',
  'profile.profileedit': 'РЕДАКТИРОВАТЬ ПРОФИЛЬ',
  'profile.licenses': 'Лицензии',
  'profile.addlicense': 'Добавить лицензию',
  'profile.removelicense': 'Удалить лицензию',
  'profile.licensetype': 'Тип',
  'profile.upload': 'загружать',
  'profile.completeprofilepoint':
    'Чтобы заработать очки, пожалуйста, заполните свой профиль ',
  'profile.licenseno': 'Лицензия №',
  'profile.addresswithoutindex': 'Адрес',
  'profile.phonewithoutindex': 'Тел.',
  'profile.underprocess': 'В процессе',
  'profile.fullname': 'Полное имя',
  'profile.airlinemarkup': 'Авиакомпании Markup',
  'profile.airlinename': 'Название авиакомпании',
  'profile.airlinetype': 'Тип авиакомпании',
  'profile.quota': 'квота',
  'profile.markup': 'Mark Up',
  'profile.savequota': 'Сохранить квоту',
  'profile.currency': 'валюта',
  'profile.passportNumber': 'Номер паспорта',
  'profile.userPointType': 'пользователь',
  'profile.point': 'Очкы',
  'profile.savepoint': 'Сохранить очкы',
  'profile.userpoint': 'Очкы Пользователя',
  'profile.subject': 'субъект',
  'profile.date': 'дата назначения',
  'profile.totaluserpoint': 'Общая пользовательская очка',
  'profile.viewdetails': 'Посмотреть детали',
  'profile.provider': 'провайдер',
  'profile.b2brequest': 'Запрос на обслуживание',
  'profile.language': 'Язык',
  'profile.department': 'департамент',
  'profile.adddetail': 'Добавить Детали (необязательно)',
  'profile.identityno': 'Идентификационный номер',
  'profile.gateway': 'Форма платежа',
  'profile.hi': 'Привет',
  'profile.status': 'Статус',
  'profile.approve': 'утверждать',
  'profile.dissapprove': 'не утверждать',
  'profile.pending': 'В ожидании',
  'profile.notexitstuser': 'Это имя пользователя не существует',
  'profile.selectrole': 'Пожалуйста, выберите департамент и роль',
  'profile.invitesuccessfully': 'Приглашение успешно отправлено',
  'profile.description': 'Описание',
  'profile.filldescription': 'Пожалуйста, введите описание',
  'profile.dashboard': 'ПРИБОРНАЯ ДОСКА',
  'profile.mydashboard': 'Моя ПРИБОРНАЯ ДОСКА',
  'profile.saleaccounting': 'отчет о продаже',
  'profile.profileaccounts': 'Управление аккаунта',
  'profile.commissionmanagement': 'Комиссия / управления очкы',
  'profile.uploadlogo': 'Загрузить логотип вашей компании',
  'profile.uploadlicense': 'Загрузите вашу лицензию',
  'profile.deleteprofile': 'Удалить профиль',
  'profile.airlineCommission': 'комиссия авиакомпании',
  'profile.licensepic': 'изображение лицензии',
  'profile.errordelete': 'Удалить эту запись невозможно',
  'profile.editverification': 'Вы уверены, что хотите удалить этот профиль',
  'profile.reference': 'Выдача полномочий',
  'profile.logotitle': 'Нажмите на опцию ниже, чтобы изменить логотип компании',
  'profile.invitedepartment':
    'Если вы хотите, пожалуйста, подтвердите приглашение ',
  'profile.inviteprofile': ' отдел в ',
  'profile.inviterole': ' бизнес-профиль с позицией ',
  'profile.invite': '.Если вы хотите, пожалуйста, подтвердите приглашение.',
  'profile.countercommission': 'Счетная комиссия',
  'profile.ownercommission': 'Комиссия владельца',
  'profile.bankaccounttype': 'тип банковского счета',
  'profile.customermanagement': 'Управление клиентами',
  'profile.active': 'активный',
  'profile.disactive': 'Деактивировать',
  'profile.Individual': 'Физическое лицо',
  'profile.bussiness': 'Бизнес',
  'profile.postalcode': 'Почтовый индекс',
  'profile.fax': 'факс',
  'profile.accountingcode': 'Кодекс бухгалтерского учета',
  'profile.deletecustomer': 'Удалить клиента',
  'profile.insertcustomer': 'Вставить клиента',
  'profile.updatecustomer': 'Обновить клиента',
  'profile.both': 'обе',
  'profile.reload': 'перезарядка',
  'profile.reloadfilter': 'Обновить фильтр',
  'profile.isbusiness': 'Это бизнес',
  'profile.isactive': 'Активен',
  'profile.name': 'название',
  'profile.registerdate': 'Дата регистрации',
  'profile.chargewallet': 'Зарядите свой кошелек',
  'profile.currentcredit': 'Текущий кредит',
  'profile.amount': 'Сумма комиссии',
  'profile.chargecreditmessgae':
    'Зарядите свой кошелек, чтобы делать покупки проще и безопаснее.',
  'profile.credit': 'Кредит :',
  'profile.startTravelDate': 'дата поездки от',
  'profile.endTravelDate': 'дата поездки в',
  'profile.paymentdate': 'Дата оплаты',
  'profile.notfound': 'записей не найдено',
  'profile.message': 'сообщение',
  'profile.mypoint': 'Моя точка зрения',
  'profile.pointtransaction': 'Балл транзакции',
  'profile.buypoints': 'Купить поинт',
  'profile.wallet': 'бумажник',
  'profile.chooseRole': 'Выберите роль',
  'profile.commission': 'комиссия',
  'profile.addQuota': 'добавить квоту',
  'profile.newQuota': 'Новая квота',
  'profile.mycredit': 'Мой кредит',
  'profile.departmentmanagement': 'Управление отделом',
  'profile.customerphrase': 'Полное наименование / бухгалтерский код',
  'profile.enterusername': 'Введите желаемое имя пользователя',
  'profile.menucredit': 'Кредит :',
  'profile.personalprofile': 'Индивидуальный профиль',
  'profile.employeesearch': 'Поиск по имени, фамилии и мобильному телефону',
  'profile.gotowalletpage': 'вернуться на страницу оплаты кошелька',
  'profile.documentdescription': 'Описание документа',
  'profile.documentnumber': 'Номер документа',
  'profile.registertime': 'Время регистрации',
  'profile.price': 'Цена',
  'profile.errorsecondpassword':
    'Второй пароль и повторение второго пароля не совпадают',
  'profile.successsecondpassword': 'Второй пароль успешно сохранен',
  'profile.insertinformation': 'Вставить информацию',
  'profile.businessprofile': 'Бизнес-профиль',
  'profile.creditmanagement': 'Управление кредитования',
  'profile.account': 'учетная запись',
  'profile.individual': 'Индивидуальный',
  'profile.business': 'бизнес',
  'profile.myfriends': 'Друзья мои',
  'profile.viewCreditsAndWallets': 'просматривать кредиты и кошельки',
  'profile.employeeManagement': 'Управление сотрудниками',
  'profile.customerManagement': 'Управление клиентами',
  'profile.financialmanagement': 'Финансовый менеджмент',
  'profile.messagedate': 'Дата сообщения',
  'profile.startMessagedate': 'Дата начала сообщения',
  'profile.endMessagedate': 'дата окончания сообщения',
  'profile.pointsremain': 'Остались баллы',
  'profile.messagedescription': 'Сообщение Описание',
  'profile.upgradeYourPlan': 'Обновите свой план',
  'profile.planCustomer': 'План клиента',
  'profile.walletbalance': 'Баланс кошелька',
  'profile.chargeamount': 'Сумма комиссии(IRR)',
  'profile.bankreceipt': 'Банковская квитанция',
  'profile.online': 'онлайн',
  'profile.increasebalance': 'Увеличить баланс',
  'profile.selectedbills': 'Избранные законопроекты',
  'profile.paymentbills': 'Оплата счетов',
  'profile.employeeList': 'Список сотрудников',
  'profile.addEmployee': 'Добавить сотрудника',
  'profile.sendingInvitation': 'Отправка приглашения',
  'profile.employee': 'Сотрудник',
  'profile.call': 'Позвонить',
  'profile.message': 'Сообщение',
  'profile.increaseOrEditCredentials': 'Увеличить или изменить учетные данные',
  'profile.sendToGroup': 'Отправить группе',
  'profile.theDesiredRole': 'Желаемая роль',
  'profile.addDepartment': 'Добавить отдел',
  'profile.employeeRole': 'Роль сотрудника',
  'profile.moreDetails': 'Подробнее',
  'profile.mehdiAbdollahiMehr': 'Mehdi Abdollahi Mehr',
  'profile.hiMessage': 'привет, ты где?',
  'profile.inWork': 'В работе',
  'profile.addNew': 'Добавить новый',
  'profile.reminding': 'Напоминание',
  'profile.participate': 'Участвовать',
  'profile.sportsInteractive': 'Sports Interactive',
  'profile.team': 'Команда',
  'profile.tasks': 'задачи',
  'profile.chooseAnArtist': 'выберите исполнителя',
  'profile.prepareForACallWithAClient': 'Подготовьтесь к разговору с клиентом',
  'profile.prepareAEKTemplateForTheClient': 'Подготовить шаблон ЭК для клиента',
  'profile.prepareDetiledBrief':
    '«Подготовьте подробный бриф для разработчиков и дизайнеров 04:12',
  'profile.more': 'Еще',
  'profile.position': 'Позиция',
  'profile.employeeInformation': 'Информация о сотруднике',
  'profile.employeeRegistrationDate': 'Дата регистрации сотрудника',
  'profile.creditAmount': 'Сумма кредита',
  'profile.theCeilingOfEachPurchase': 'потолок каждой покупки',
  'profile.validityDuration': 'Срок действия',
  'profile.creditStatus': 'Кредитный статус',
  'profile.increaseCredit': 'Увеличить кредит',
  'profile.editCredit': 'Изменить кредит',
  'profile.employeeCredit': 'Кредит сотруднику',
  'profile.creditBalance': 'Остаток кредита',
  'profile.aboutme': 'Обо мне',
  'profile.myfavouritecity': 'Мои любимые города',
  'profile.loan': 'Заем',
  'profile.gift': 'Подарок',
  'profile.messageType': 'Тип сообщения',
  'profile.text': 'Текст',
  'profile.file': 'Файл',
  'profile.totalPurchaseAmount': 'Общая сумма покупки',
  'profile.topCustomers': 'Лучшие клиенты',
  'profile.homeAppliancesSeller': 'Продавец бытовой техники',
  'profile.pointsInventory': 'Inventario punti',
  'profile.pointCard': 'Carta punti',
  'profile.pointsInventory': 'Points inventory',
  'profile.pointCard': 'Point card',
  'profile.shoppingList': 'Список покупок',
  'profile.customerInformation': 'Информация о клиенте',
  'profile.customerRegistrationDate': 'Дата регистрации клиента',
  'profile.customerShoppingList': 'Список покупок клиентов',
  'profile.romaAirlines': 'Рома Эйрлайнз',
  'profile.incomeFromTheCustomer': 'Доход от клиента',
  'profile.companyAddress': 'Адрес компании',
  'profile.nameOfCEO': 'Имя генерального директора',
  'profile.registration / priceChange': 'Регистрация / изменение цены',
  'profile.printPassengerInvoice': 'Распечатать счет пассажира',
  'profile.registrationPaymentReceipts': 'Оформление квитанций об оплате',
  'profile.priceToBuyFromOwner': 'Цена на покупку у доньяро',
  'profile.salesPriceCustomer': 'Цена продажи для покупателя',
  'profile.salesManager': 'Менеджер по продажам',
  'profile.showLess': 'Показывать меньше',
  'profile.purchaseRate': 'Скорость покупки',
  'profile.changeTicketSalesRates': 'Изменить курс продажи билетов',
  'profile.savePrice': 'Сохранить цену',
  'profile.remainingAmount': 'Остаток',
  'profile.firstPayment': 'Первый платеж',
  'profile.settlementOfTickets': 'Расчет билетов',
  'profile.totalAmount': 'Общая сумма',
  'profile.attachedPaymentReceipt': 'Прикрепленная квитанция об оплате',
  'profile.attachedPaymentReceipt1': 'Первый прикрепленный квитанция',
  'profile.attachedPaymentReceipt2': 'Вторая прикрепленная квитанция',
  'profile.attachedPaymentReceipt3': 'Третья прикрепленная квитанция',
  'profile.attachedPaymentReceipt4': 'Четвертая прикрепленная квитанция',
  'profile.attachedPaymentReceipt5': 'Пятая прикрепленная квитанция',
  'profile.totalRemaining': 'Всего осталось',
  'profile.saveAndNextReceipt': 'Сохранить и следующую квитанцию',
  'profile.saveAndExit': 'Сохранить и выйти',
  'profile.travel': 'Путешествовать',
  'profile.editconfirmation':
    'Отправив запрос на редактирование, ваш профиль будет заблокирован до тех пор, пока он не будет одобрен Tripsi. Вы согласны?',
  'profile.searchtobuy': 'Соотношение поиска и покупки',
  'profile.listOfPassengers': 'Список пассажиров',
  'profile.me': 'Tell about yourself.Get points',
  'profile.customer': 'клиент',
  'profile.addcity': 'Добавить город',
  'profile.showinfo': 'Показать информацию',
  'profile.editPassengerInformation': 'Редактировать информацию о пассажирах',
  'profile.yourPassengerHasBeenSuccessfullyRegistered':
    'Ваш пассажир успешно зарегистрирован',
  'profile.theRequestedPassengerInformationWasSuccessfullyEdited':
    'Запрошенная информация о пассажире успешно отредактирована',
  'profile.customerSuccessfullyRegistered': 'Клиент успешно зарегистрирован',
  'profile.theDesiredCustomerInformationWasSuccessfullyEdited':
    'Требуемая информация о клиенте была успешно отредактирована',
  'profile.addfriend': 'Добавить друга',
  'profile.inveitefriend': 'Пригласить друзей',
  'profile.editEmployeeSuccessfully': 'Изменить сотрудника успешно',
  'profile.updateEmployeeSuccess': 'Информация о сотруднике успешно изменена',
  'profile.mostSales': 'Большинство продаж',
  'profile.theLowestNumberOfSales': 'Самые низкие продажи',
  'profile.mostSalesAmount': 'Наибольшая сумма продаж',
  'profile.theLowestSalesAmount': 'Самая низкая сумма продаж',
  'profile.mostActivityTime': 'Время наибольшей активности',
  'profile.minimumActivityTime': 'Минимальное время активности',
  'profile.employeeActivities': 'Деятельность сотрудников',
  'profile.applyChanges': 'Применить изменения',
  'profile.planPassenger': 'План пассажира',
  'профиль.все': 'все',
  'profile.Activities': 'виды деятельности',
  'profile.allProfiles': 'профили',
  'profile.allStatuses': 'Все статусы',
  'profile.dragtoadd': 'Перетащите, чтобы добавить',
  'profile.dragtotransfer': 'Перетащите, чтобы передать',
  'profile.alltransactions': 'Все транзакции',
  'profile.allusers': 'Все пользователи',
  'profile.recentTravels': 'Недавние путешествия',
  'profile.mounthReport': 'Отчет об эффективности за последний месяц',
  'profile.recentNews': 'Свежие новости',
  'profile.tourismNews': 'Новости туризма',
  'profile.donutChart': 'Совершено путешествий',
  'profile.recentMonthActivitie': 'Действия за последний месяц',
  'profile.NumberFlightPurchases': 'Количество покупок авиабилетов',
  'profile.NumberFlightSearches': 'Количество поисков рейсов',
  'profile.agree': 'Соглашаться',
  'profile.changeLogo': 'Изменить логотип',
  'profile.editingInformation': 'Информация о редактировании',
  'profile.webSite': 'Веб-сайт',
  'profile.phone': 'Телефон',
  'profile.address': 'Адрес',
  'profile.presensnt': 'перечувствовать',
  'profile.absence': 'отсутствие',
  'profile.leave': 'оставлять',
  'profile.inviteEmployees': 'пригласить сотрудников',
  'profile.textEmployees':
    'Через форму ниже вы можете отправить приглашения сотрудникам, которые покинули их компанию и имеют активные логины и их в свою коллекцию .',
  'profile.addEmployees': 'добавить сотрудников',
  'profile.textAddemplo':
    'Через форму ниже вы можете добавлять новых сотрудников в компанию и контролировать их работу с помощью различных функций системы .',
  'profile.copy': 'скопировано',
  'profile.editEmployeeInformation': 'Изменить информацию о сотруднике',
  'profile.purchases': 'покупки',
  'profile.addCustomer': 'Добавить клиента',
  'profile.textCustomer':
    'Через следующую форму вы можете добавить желаемых клиентов в коллекцию, заполнив следующую информацию .',

  'profile.customerList': 'Список клиентов',
  'profile.changedate': 'Дата изменения',
  'profile.services': 'Наши услуги',
  'profile.tourManagement': 'Управление туром',
  'profile.onlineFriend': 'мои онлайн друзья',
  'profile.reservations': 'Бронирование',
  'profile.row': 'строка',
  'profile.transactions': 'Транзакции',
  'profile.searchHistory': 'История поиска',
  'profile.Transactions': 'Транзакции',
  'profile.Invoices': 'Счета',
  'profile.assetManagment': 'Управление активами',
  'profile.transaction': 'Транзакции',
  'profile.Invoice': 'счет',
  'profile.Invite': 'Приглашать',
  'profile.add': 'добавлять',
  'profile.passengers': 'Пассажиры',
  'profile.messages': 'Сообщения',
  'profile.Services': 'Услуги',
  'profile.messageNo': 'Номер сообщения',
  'profile.viewInvoice': 'Посмотреть счет',
  'profile.flight': 'полет',
  'profile.paid': 'Оплаченный',
  'profile.unpaid': 'Неоплачиваемый',
  'profile.choosefile': 'Выбрать файл',
  'profile.sellername': `Имя продавца`,
  'profile.factoreno': 'Фактор №',
  'profile.customername': 'Имя Клиента',
  'profile.phonenumber': 'Номер мобильного телефона',
  'profile.printinvoice': 'Распечатать счет',
  'profile.signature': 'Бухгалтерская печать и подпись',
  'profile.signaturetext':
    'Без печати и подписи бухгалтерский учет недействителен.',
  'profile.servicedescription': 'Описание услуг',
  'profile.taxesduties': 'Налоги и пошлины',
  'profile.purchaseamount': 'Сумма покупки',
  'profile.friendsearch': 'Имя, Национальный код, № паспорта',
  'profile.ticketsearch': 'Название, номер билета',
  'profile.messagesearch': 'Тема, номер сообщения',
  'profile.bookingflightsearch': 'Имя, номер заказа',
  'profile.transactionsearch': 'Имя, номер заказа',
  'profile.employeesearch': 'Имя, электронная почта',
  'profile.customersearch': 'Имя Клиента',
  'profile.passangersearch': 'Имя, Национальный код, № паспорта',
  'profile.activities': 'Деятельность',
  'profile.addlicenselink': 'Добавить лицензию',
  'profile.startnewsevent': 'Начать мероприятие',
  'profile.endnewsevent': 'Конечное событие',
  'profile.descriptionnews': 'Текст новости : ',
  'profile.introduction': 'Введение',
  'profile.firsttravel': 'В ожидании первой поездки...',
  'profile.transactionnumber': 'Код транзакции : ',
  'profile.notfoundnews': 'Не найдено новостей',
  'profile.notfoundtravel': `Вы еще не путешествовали.`,
  'profile.waitingTrip': 'Ждём вашего первого путешествия...',
  'profile.addLicenseText':
    'Через форму ниже вы можете ввести свои разрешения и зарегистрировать информацию в конце.',
  'profile.simpleuser': 'Обычный пользователь',
  'profile.owner': 'Владелец',
  'profile.crm': 'CRM',
  'profile.counter': 'Прилавок',
  'profile.accountants': 'Бухгалтеры',
  'profile.roles': 'Роли',
  'profile.submitchangerate': 'Изменение уровня продаж прошло успешно',
  'profile.paymentprice': 'цена платежа',
  'profile.savesuccessfully': 'Сохранено успешно',
  'profile.viewfile': 'Просмотреть файл',
  'profile.backgammon': 'бакгаммон',
  'profile.chatgpt': 'chat gpt',
  'profile.calendar': 'календарь',
  'profile.game': 'Игра',
  'profile.addgateway': 'Добавить маршрут полета',
  'profile.editgateway': 'Редактировать маршрут полета',
  'profile.addgatewaydescription':
    'В этой форме вы можете зарегистрировать желаемый маршрут полета. После регистрации поиски будут проводиться в соответствии с зарегистрированными маршрутами полета',
  'profile.editgatewaydescription':
    'В этой форме вы можете редактировать желаемый маршрут полета. После редактирования поиски будут проводиться в соответствии с зарегистрированными маршрутами полета',
  'profile.gatewayroutes': 'Маршруты полета',
  'profile.airlinecode': 'Код авиакомпании',
  'profile.internalcode': 'Внутренний код',
  'profile.weekdays': 'Дни недели',
  'profile.known': 'Известно',
  'profile.unknown': 'Неизвестно',
  'profile.airlinestatus': 'Статус авиакомпании',
  'profile.allroutes': 'Все маршруты',
  'profile.selectoriginanddestination': 'Выбор пункта отправления и назначения',
  'profile.siti': 'Сити',
  'profile.sito': 'Сито',
  'profile.soti': 'Соти',
  'profile.soto': 'Сото',
  'profile.pathchoice': 'Выбор маршрута',
  'profile.submiteditgateway': 'Подтвердить редактирование маршрута',
  'profile.submitaddgateway': 'Подтвердить добавление маршрута',
  'profile.selectflightsdays': 'Выбрать дни полетов',
  'profile.departureflightcity': 'Город отправления полета',
  'profile.arrivalflightcity': 'Город прибытия полета',
  'profile.ascinternalcode': 'Восходящий порядок внутреннего кода',
  'profile.descinternalcode': 'Нисходящий порядок внутреннего кода',
  'profile.ascairlinecode': 'Восходящий порядок кода авиакомпании',
  'profile.descairlinecode': 'Нисходящий порядок кода авиакомпании',
  'profile.addgatewaysuccessfully': 'Маршрут полета успешно зарегистрирован',
  'profile.editgatewaysuccessfully': 'Маршрут полета успешно отредактирован',
  'profile.notallowed': 'Невозможно выбрать профиль до его одобрения',
  'profile.addcustomerduplicated': 'Желаемый клиент уже зарегистрирован',
  'profile.loading': 'Загрузка...',
  'profile.textAddfriend':
    'Вы можете отправить приглашение своим друзьям через следующую форму и добавить их в свой список друзей.',
  'profile.reservations': 'Бронирование',
  'profile.clubCard': 'Клубная карта',
  'profile.Invoices': 'Счета-фактуры',
  'profile.textEditingTripsi':
    'Вы можете изменить информацию в своем профиле с помощью формы ниже. Обратите внимание, что после внесения изменений в профиль он будет приостановлен до одобрения Tripsi.',
  'profile.textEditingTripord':
    'Вы можете изменить информацию в своем профиле с помощью формы ниже. Обратите внимание, что после внесения изменений в профиль он будет приостановлен до одобрения Tripord.',
  'profile.textPassword':
    'Вы можете изменить свой пароль и задать новый пароль с помощью формы ниже.',
  'profile.textDepartment':
    'Вы можете зарегистрировать или переадресовать нужный отдел с помощью формы ниже.',
  'profile.transferType': 'Тип передачи',
  'profile.transferamount': 'Сумма перевода',
  'profile.sendfile': 'Отправить банковскую квитанцию',
  'profile.sendfiles': 'Отправить банковские квитанции',
  'profile.factorestartdate': 'Дата начала счета',
  'profile.factoreenddate': 'Дата окончания счета',
  'profile.factoredate': 'Дата счета',
  'profile.allfactors': 'Все счета',
  'profile.walletnotenough': 'Баланс кошелька недостаточен',
  'profile.approvePrice': 'Утвержденная цена',
  'profile.oldsecondpassword': 'Старый второй пароль',
  'profile.setSecondPasswordInfo':
    'Если вы устанавливаете второй пароль впервые, вводить это поле не нужно.',
};
